import React from 'react';

/**
 * ColoredButton
 * Props:
 * - onClick: function
 * - disabled: boolean
 * - bgColor: background color (string)
 * - color: text/icon color (string)
 * - borderColor: optional border color
 * - size: 'sm' | 'md' | 'lg'
 * - radius: borderRadius (string)
 * - icon: React node
 * - children: label
 * - style: extra style object
 */
export default function ColoredButton({
  onClick,
  disabled = false,
  bgColor = '#3b82f6',
  color = '#ffffff',
  borderColor = 'transparent',
  size = 'md',
  radius = '8px',
  icon = null,
  children = null,
  style = {},
  title = '',
  type = 'button',
}) {
  const sizes = {
    sm: { padding: '6px 8px', fontSize: '0.75rem' },
    md: { padding: '8px 10px', fontSize: '0.875rem' },
    lg: { padding: '10px 14px', fontSize: '1rem' },
  };

  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    borderRadius: radius,
    border: `1px solid ${borderColor}`,
    background: disabled ? 'rgba(0,0,0,0.12)' : bgColor,
    color: disabled ? 'rgba(255,255,255,0.6)' : color,
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'transform 0.08s ease, box-shadow 0.08s ease',
    boxShadow: disabled ? 'none' : '0 2px 8px rgba(0,0,0,0.08)',
    outline: 'none',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    ...sizes[size],
    ...style,
  };

  return (
    <button
      type={type}
      title={title}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={base}
    >
      {icon}
      {children}
    </button>
  );
}
